import React from 'react';
import { Image, Text, Stack, DefaultButton } from '@fluentui/react';
import './NoPage.css';
import NotFoundPImg from "../assets/404.png";

const NoPage: React.FC = () => {
    const handleBackToHome = () => {
        window.location.href = 'https://kust.ai/';
    };

    return (
        <Stack className="container" tokens={{ childrenGap: 20 }} verticalAlign="center" horizontalAlign="center">
            <Text variant="xxLarge" className="heading">404</Text>
            <Image src={NotFoundPImg} alt="404 Icon" />
            <Text variant="large" className="text">Page Not Found</Text>
            <DefaultButton className="button" onClick={handleBackToHome}>
                Back to Home
            </DefaultButton>
        </Stack>
    );
};

export default NoPage;
